// Comprehensive Edible Oils & Fats Catalogue Data for SPANXPORT

export const edibleOilsData = [
  {
    id: "groundnut-oil",
    name: "Groundnut Oil (Peanut Oil)",
    botanicalName: "Arachis hypogaea",
    family: "Fabaceae",
    source: "Peanut/Groundnut seeds",
    image: "groundnut-oil",
    description: "Groundnut oil, also known as peanut oil, is a mild-tasting vegetable oil derived from peanuts. It has a high smoke point making it ideal for frying. The oil is pale yellow with a pleasant nutty aroma. Cold-pressed varieties retain more flavor and nutrients.",
    extraction: "Groundnut oil is extracted through mechanical pressing or solvent extraction. Cold-pressed oil retains natural flavor and nutrients. Refined oil undergoes degumming, neutralization, bleaching, and deodorization for a neutral taste and longer shelf life.",
    nutritionalProfile: "Rich in monounsaturated fats (MUFA) and polyunsaturated fats (PUFA). Contains vitamin E, phytosterols, and resveratrol. Low in saturated fats. Provides approximately 884 calories per 100ml.",
    uses: "Widely used for deep frying due to high smoke point (450°F/232°C). Popular in Asian and African cuisines. Used in salad dressings, marinades, and baking. Also used in cosmetics and pharmaceuticals.",
    healthBenefits: "Supports heart health due to MUFA content. Rich in antioxidants. May help reduce cholesterol levels. Contains resveratrol which has anti-inflammatory properties.",
    storageShelfLife: "Store in a cool, dark place. Refined oil lasts 1-2 years unopened. Cold-pressed oil should be used within 6 months. Refrigeration extends shelf life.",
    indianNames: {
      Hindi: "Mungfali Ka Tel",
      Bengali: "Chinabadam Tel",
      Gujarati: "Singtel",
      Marathi: "Shengdana Tel",
      Tamil: "Verkadalai Ennai",
      Telugu: "Verusenaga Nune"
    },
    specifications: {
      colorRange: "Light yellow to golden",
      smokePoint: "232°C (450°F)",
      density: "0.912-0.920 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      moistureContent: "Max 0.1%"
    },
    category: "vegetable"
  },
  {
    id: "sesame-oil",
    name: "Sesame Oil (Gingelly Oil)",
    botanicalName: "Sesamum indicum",
    family: "Pedaliaceae",
    source: "Sesame seeds",
    image: "sesame-oil",
    description: "Sesame oil is one of the oldest known oilseed crops. It comes in two varieties: light sesame oil from raw seeds with a mild flavor, and dark/toasted sesame oil from roasted seeds with an intense nutty aroma. Highly valued in Asian cuisines.",
    extraction: "Traditional cold-pressing (Chekku/Ghani method) produces flavorful oil. Modern expeller pressing and solvent extraction are also used. Toasted sesame oil is made from roasted seeds. The oil is naturally resistant to oxidation.",
    nutritionalProfile: "Contains equal amounts of monounsaturated and polyunsaturated fats. Rich in sesamol and sesamin (unique antioxidants). Good source of vitamin E and K. Contains omega-6 fatty acids.",
    uses: "Essential in Asian cooking, especially Chinese, Korean, and Japanese cuisines. Used as finishing oil for flavor. Light sesame oil suitable for high-heat cooking. Used in Ayurvedic massage (Abhyanga) and oil pulling.",
    healthBenefits: "Powerful antioxidant properties from sesamol. Supports heart health and blood pressure regulation. Anti-inflammatory effects. Traditional use for oral health. May help regulate blood sugar.",
    storageShelfLife: "Naturally stable due to antioxidants. Store in dark glass bottles away from heat. Lasts 6-12 months. Toasted oil should be refrigerated after opening.",
    indianNames: {
      Hindi: "Til Ka Tel",
      Bengali: "Til Tel",
      Gujarati: "Tal Nu Tel",
      Kannada: "Ellu Enne",
      Malayalam: "Ellu Enna",
      Tamil: "Nalla Ennai",
      Telugu: "Nuvvula Nune"
    },
    specifications: {
      colorRange: "Light golden to dark amber",
      smokePoint: "210°C (410°F) light / 177°C (350°F) toasted",
      density: "0.917-0.923 g/ml",
      freefattyAcids: "Max 2% (cold-pressed)",
      moistureContent: "Max 0.2%"
    },
    category: "vegetable"
  },
  {
    id: "mustard-oil",
    name: "Mustard Oil",
    botanicalName: "Brassica juncea / Brassica nigra",
    family: "Brassicaceae",
    source: "Mustard seeds",
    image: "mustard-oil",
    description: "Mustard oil is a pungent, amber-colored oil with a distinctive sharp, hot flavor. It's a staple cooking medium in Eastern India, Bangladesh, and Pakistan. The oil contains allyl isothiocyanate which gives it its characteristic pungency that mellows when heated.",
    extraction: "Traditionally extracted through cold-pressing (Kachi Ghani method). The seeds are ground and pressed without heat to retain flavor and nutrients. Refined mustard oil has reduced pungency. Some oil is extracted using solvent methods.",
    nutritionalProfile: "High in monounsaturated fats (erucic acid) and polyunsaturated fats (alpha-linolenic acid - omega-3). Contains glucosinolates. Good source of vitamin E. Ideal omega-6 to omega-3 ratio.",
    uses: "Primary cooking oil in Eastern and Northern India. Used for pickling and preserving. Essential in Bengali, Bihari, and Assamese cuisines. Used for body massage in traditional practices. Applied to hair for conditioning.",
    healthBenefits: "Antibacterial and antifungal properties. Stimulates digestion. Traditionally used for respiratory relief. May support cardiovascular health. Used in Ayurveda for various treatments.",
    storageShelfLife: "Store in dark, airtight containers. Shelf life of 6-12 months. Pungency may decrease over time. Best stored away from light and heat.",
    indianNames: {
      Hindi: "Sarson Ka Tel",
      Bengali: "Sorsher Tel",
      Gujarati: "Rai Nu Tel",
      Punjabi: "Sarson Da Tel",
      Assamese: "Soriar Tel",
      Odia: "Sorisa Tela"
    },
    specifications: {
      colorRange: "Dark yellow to amber",
      smokePoint: "254°C (489°F)",
      density: "0.914-0.920 g/ml",
      freefattyAcids: "Max 1% (Kachi Ghani)",
      erucicAcid: "22-50%"
    },
    category: "vegetable"
  },
  {
    id: "coconut-oil",
    name: "Coconut Oil",
    botanicalName: "Cocos nucifera",
    family: "Arecaceae",
    source: "Coconut meat (copra)",
    image: "coconut-oil",
    description: "Coconut oil is extracted from the meat of mature coconuts. It's solid at room temperature due to high saturated fat content. Virgin coconut oil (VCO) retains the coconut aroma and flavor, while refined oil is neutral. Highly stable and resistant to rancidity.",
    extraction: "Virgin coconut oil is extracted from fresh coconut meat through cold-pressing or centrifugation. Copra oil is extracted from dried coconut meat. RBD (Refined, Bleached, Deodorized) oil undergoes extensive processing for neutral taste.",
    nutritionalProfile: "High in saturated fats (82%), primarily medium-chain triglycerides (MCTs) including lauric acid. Contains small amounts of vitamin E and K. MCTs are metabolized differently than long-chain fats.",
    uses: "Popular cooking oil in South India, Sri Lanka, and Southeast Asia. Used in baking and confectionery. Key ingredient in cosmetics and skincare. Used for hair care and oil pulling. Base for many Ayurvedic preparations.",
    healthBenefits: "MCTs may boost metabolism. Lauric acid has antimicrobial properties. Excellent for skin and hair care. May support brain function. Used in ketogenic diets.",
    storageShelfLife: "Highly stable due to saturated fat content. Shelf life of 2+ years. No refrigeration needed. Melts above 24°C (76°F). Store away from direct sunlight.",
    indianNames: {
      Hindi: "Nariyal Ka Tel",
      Bengali: "Narkel Tel",
      Gujarati: "Nadiyer Tel",
      Kannada: "Thenginakayi Enne",
      Malayalam: "Velichenna",
      Tamil: "Thengai Ennai",
      Telugu: "Kobbari Nune"
    },
    specifications: {
      colorRange: "White (solid) to clear (liquid)",
      smokePoint: "177°C (350°F) virgin / 204°C (400°F) refined",
      density: "0.915-0.920 g/ml",
      freefattyAcids: "Max 0.5% (VCO)",
      lauricAcid: "45-52%"
    },
    category: "tropical"
  },
  {
    id: "sunflower-oil",
    name: "Sunflower Oil",
    botanicalName: "Helianthus annuus",
    family: "Asteraceae",
    source: "Sunflower seeds",
    image: "sunflower-oil",
    description: "Sunflower oil is a light, mild-flavored oil extracted from sunflower seeds. It's one of the most popular cooking oils worldwide due to its neutral taste and high smoke point. Available in high-oleic and high-linoleic varieties with different fatty acid profiles.",
    extraction: "Seeds are cleaned, dehulled, and pressed. Cold-pressed oil retains more nutrients. Solvent extraction followed by refining produces most commercial oil. High-oleic varieties are bred for improved stability.",
    nutritionalProfile: "High in polyunsaturated fats (linoleic acid) or monounsaturated fats (oleic acid) depending on variety. Excellent source of vitamin E. Low in saturated fats. Contains phytosterols.",
    uses: "Versatile cooking oil suitable for frying, baking, and salad dressings. Used in margarine production. Popular in food manufacturing. High-oleic variety preferred for commercial frying.",
    healthBenefits: "Rich in vitamin E antioxidants. May support heart health. High-oleic variety more stable for cooking. Contains phytosterols that may reduce cholesterol absorption.",
    storageShelfLife: "Store in cool, dark place. Refined oil lasts 1-2 years. High-oleic variety more stable. Refrigerate after opening for extended freshness.",
    indianNames: {
      Hindi: "Surajmukhi Ka Tel",
      Bengali: "Surjomukhi Tel",
      Gujarati: "Surajmukhi Tel",
      Marathi: "Suryaphul Tel",
      Tamil: "Suriyakanthi Ennai",
      Telugu: "Poddutiruguda Nune"
    },
    specifications: {
      colorRange: "Light yellow to golden",
      smokePoint: "227°C (440°F) refined",
      density: "0.918-0.923 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      vitaminE: "40-50 mg/100g"
    },
    category: "vegetable"
  },
  {
    id: "soybean-oil",
    name: "Soybean Oil",
    botanicalName: "Glycine max",
    family: "Fabaceae",
    source: "Soybeans",
    image: "soybean-oil",
    description: "Soybean oil is the world's most widely used vegetable oil. It has a neutral flavor and is highly versatile. The oil is extracted from soybeans and undergoes refining for commercial use. It's a major component in many processed foods.",
    extraction: "Soybeans are cracked, heated, and flaked before solvent extraction with hexane. The crude oil undergoes degumming, neutralization, bleaching, and deodorization. Some cold-pressed and expeller-pressed options available.",
    nutritionalProfile: "Balanced fatty acid profile with polyunsaturated (58%), monounsaturated (23%), and saturated fats (16%). Good source of omega-6 and omega-3 fatty acids. Contains vitamin K and E. Rich in lecithin.",
    uses: "Widely used in commercial food production. Popular for frying and baking. Base for margarine and shortening. Used in salad dressings and mayonnaise. Industrial applications include biodiesel.",
    healthBenefits: "Contains both omega-6 and omega-3 fatty acids. Vitamin K supports bone health. May help lower cholesterol. Lecithin supports brain function.",
    storageShelfLife: "Store in cool, dark conditions. Shelf life of 1 year for refined oil. More prone to oxidation than some oils. Refrigerate after opening.",
    indianNames: {
      Hindi: "Soyabean Ka Tel",
      Bengali: "Soyabean Tel",
      Gujarati: "Soybean Tel",
      Marathi: "Soybean Tel",
      Tamil: "Soya Ennai",
      Telugu: "Soya Nune"
    },
    specifications: {
      colorRange: "Light yellow",
      smokePoint: "234°C (453°F) refined",
      density: "0.917-0.924 g/ml",
      freefattyAcids: "Max 0.05% (refined)",
      linoleicAcid: "50-55%"
    },
    category: "vegetable"
  },
  {
    id: "rice-bran-oil",
    name: "Rice Bran Oil",
    botanicalName: "Oryza sativa",
    family: "Poaceae",
    source: "Rice bran (outer layer of rice grain)",
    image: "rice-bran-oil",
    description: "Rice bran oil is extracted from the nutrient-rich outer layer of rice. It has gained popularity as a healthy cooking oil due to its balanced fatty acid composition and unique antioxidants. The oil has a mild flavor and high smoke point.",
    extraction: "Rice bran must be processed quickly after milling to prevent lipase enzyme activity. Extraction uses solvent or expeller methods. Refining removes waxes and produces clear oil. Oryzanol is a unique component preserved during processing.",
    nutritionalProfile: "Balanced ratio of saturated, monounsaturated, and polyunsaturated fats. Contains gamma-oryzanol (unique antioxidant). Rich in tocotrienols (vitamin E form). Contains phytosterols and squalene.",
    uses: "Excellent for high-temperature cooking and deep frying. Popular in Asian cuisines, especially Japanese tempura. Used in salad dressings and baking. Growing use in food manufacturing.",
    healthBenefits: "Gamma-oryzanol may lower cholesterol. Balanced fatty acid profile supports heart health. High antioxidant content. May help manage blood sugar. Supports skin health.",
    storageShelfLife: "Good stability due to antioxidants. Store in cool, dark place. Shelf life of 6-12 months. Does not require refrigeration.",
    indianNames: {
      Hindi: "Chawal Ki Bhusi Ka Tel",
      Bengali: "Chaul Tel",
      Tamil: "Arisi Thavidu Ennai",
      Telugu: "Biyyam Tokkulu Nune"
    },
    specifications: {
      colorRange: "Light yellow to amber",
      smokePoint: "254°C (490°F)",
      density: "0.916-0.921 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      oryzanol: "1.5-2.5%"
    },
    category: "vegetable"
  },
  {
    id: "safflower-oil",
    name: "Safflower Oil",
    botanicalName: "Carthamus tinctorius",
    family: "Asteraceae",
    source: "Safflower seeds",
    image: "safflower-oil",
    description: "Safflower oil comes from the seeds of the safflower plant, historically grown for its flowers' dye. Two types exist: high-linoleic (polyunsaturated) and high-oleic (monounsaturated). The oil is colorless and flavorless, making it versatile.",
    extraction: "Seeds are cleaned, cracked, and pressed or solvent-extracted. Cold-pressing available for specialty markets. Refining produces neutral-flavored oil. High-oleic varieties developed for stability.",
    nutritionalProfile: "High-linoleic: 78% polyunsaturated fat. High-oleic: 78% monounsaturated fat. Very low in saturated fat (6-8%). Good source of vitamin E. Contains no cholesterol.",
    uses: "High-oleic variety excellent for high-heat cooking. High-linoleic variety better for cold applications. Used in salad dressings and margarine. Popular in food manufacturing. Used in cosmetics and paints.",
    healthBenefits: "High-oleic variety supports heart health. May help improve blood sugar control. Vitamin E provides antioxidant benefits. Low saturated fat content.",
    storageShelfLife: "High-oleic variety more stable. Store away from heat and light. Shelf life of 1-2 years for refined oil. High-linoleic variety should be used faster.",
    indianNames: {
      Hindi: "Kusum Ka Tel",
      Bengali: "Kusum Tel",
      Gujarati: "Kusum Tel",
      Marathi: "Kardai Tel",
      Kannada: "Kusumbe Enne"
    },
    specifications: {
      colorRange: "Colorless to pale yellow",
      smokePoint: "266°C (510°F) high-oleic",
      density: "0.922-0.927 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      oleicAcid: "75-80% (high-oleic variety)"
    },
    category: "vegetable"
  },
  {
    id: "cottonseed-oil",
    name: "Cottonseed Oil",
    botanicalName: "Gossypium hirsutum",
    family: "Malvaceae",
    source: "Cotton plant seeds",
    image: "cottonseed-oil",
    description: "Cottonseed oil is a byproduct of cotton production, extracted from cotton seeds after ginning. It was one of the first oils to be industrially produced. The oil has a mild, nutty flavor and is commonly used in food manufacturing.",
    extraction: "Cottonseed is cleaned and dehulled. Oil extracted through pressing or solvent extraction. Crude oil contains gossypol (toxic) which is removed through refining. Fully refined oil is safe for consumption.",
    nutritionalProfile: "Balanced fatty acid profile: 26% saturated, 18% monounsaturated, 52% polyunsaturated. Good source of vitamin E. Contains no cholesterol. Rich in linoleic acid.",
    uses: "Popular for commercial frying (stable at high temperatures). Used in snack food production. Component in margarine and shortening. Used in salad dressings. Traditional use in Southern US cooking.",
    healthBenefits: "Good source of vitamin E. May help lower cholesterol. Balanced fatty acid profile. Contains tocopherols with antioxidant properties.",
    storageShelfLife: "Relatively stable due to natural antioxidants. Store in cool, dark place. Shelf life of 1-2 years. May solidify slightly in cold temperatures.",
    indianNames: {
      Hindi: "Binola Ka Tel",
      Bengali: "Tula Tel",
      Gujarati: "Kapas Tel",
      Tamil: "Paruthi Ennai",
      Telugu: "Patti Nune"
    },
    specifications: {
      colorRange: "Pale yellow to golden",
      smokePoint: "216°C (420°F)",
      density: "0.918-0.926 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      linoleicAcid: "50-55%"
    },
    category: "vegetable"
  },
  {
    id: "palm-oil",
    name: "Palm Oil",
    botanicalName: "Elaeis guineensis",
    family: "Arecaceae",
    source: "Oil palm fruit",
    image: "palm-oil",
    description: "Palm oil is derived from the fruit of oil palm trees. It's the world's most produced vegetable oil. Red palm oil (unrefined) is rich in carotenoids, while refined palm oil is neutral. Palm kernel oil is extracted from the seed.",
    extraction: "Fresh fruit bunches are sterilized, stripped, and pressed. Crude palm oil is red due to carotenoids. Refining bleaches and deodorizes the oil. Fractionation separates palm olein (liquid) and palm stearin (solid).",
    nutritionalProfile: "Balanced saturated (50%) and unsaturated (50%) fats. Red palm oil rich in beta-carotene and vitamin E (tocotrienols). Contains no trans fats. Palm olein has more unsaturated fats.",
    uses: "Widely used in food manufacturing (biscuits, margarine, ice cream). Used for frying due to stability. Red palm oil used in African cooking. Palm kernel oil used in cosmetics.",
    healthBenefits: "Red palm oil is rich in antioxidants. Contains no trans fats. Tocotrienols may have cardiovascular benefits. Stable for cooking.",
    storageShelfLife: "Very stable due to saturated fat content. Long shelf life of 2+ years. Store at room temperature. May solidify in cool conditions.",
    indianNames: {
      Hindi: "Palm Tel",
      Bengali: "Palm Tel",
      Tamil: "Panai Ennai",
      Telugu: "Tati Nune"
    },
    specifications: {
      colorRange: "Red-orange (crude) to white/yellow (refined)",
      smokePoint: "235°C (455°F)",
      density: "0.891-0.899 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      betaCarotene: "500-700 ppm (crude)"
    },
    category: "tropical"
  },
  {
    id: "castor-oil",
    name: "Castor Oil",
    botanicalName: "Ricinus communis",
    family: "Euphorbiaceae",
    source: "Castor beans",
    image: "castor-oil",
    description: "Castor oil is a unique vegetable oil with distinctive properties due to its high ricinoleic acid content (90%). It's very viscous and has numerous industrial and medicinal applications. Not typically used for cooking but invaluable in industry.",
    extraction: "Castor beans are cleaned and dehulled. Oil extracted through pressing or solvent extraction. Cold-pressed oil preferred for pharmaceutical use. Toxic ricin remains in the seed cake.",
    nutritionalProfile: "Unique composition: 90% ricinoleic acid (hydroxylated fatty acid). Also contains oleic and linoleic acids. Not consumed as food oil. Used topically and medicinally.",
    uses: "Industrial lubricant and hydraulic fluid. Base for cosmetics and soaps. Pharmaceutical applications (laxative). Used in plastics and coatings. Hair and skin care products.",
    healthBenefits: "Traditional laxative (when taken orally under guidance). Moisturizing for skin and hair. Anti-inflammatory properties topically. Used in Ayurvedic treatments.",
    storageShelfLife: "Very stable due to unique structure. Shelf life of 2-5 years. Store in cool, dark place. Does not easily oxidize.",
    indianNames: {
      Hindi: "Arandi Ka Tel",
      Bengali: "Rerira Tel",
      Gujarati: "Divelno Tel",
      Kannada: "Haralu Enne",
      Malayalam: "Avanakku Enna",
      Tamil: "Amanakku Ennai",
      Telugu: "Amudamu"
    },
    specifications: {
      colorRange: "Pale yellow to colorless",
      viscosity: "Very high (650-1000 cP)",
      density: "0.957-0.968 g/ml",
      ricinoleicAcid: "85-92%",
      iodineValue: "82-90"
    },
    category: "industrial"
  },
  {
    id: "linseed-oil",
    name: "Linseed Oil (Flaxseed Oil)",
    botanicalName: "Linum usitatissimum",
    family: "Linaceae",
    source: "Flax seeds (linseeds)",
    image: "linseed-oil",
    description: "Linseed oil, also known as flaxseed oil, is one of the richest plant sources of omega-3 fatty acids (alpha-linolenic acid). Cold-pressed food-grade oil is a nutritional supplement. Industrial linseed oil is used in paints and finishes.",
    extraction: "Food-grade oil is cold-pressed from fresh flax seeds. Industrial oil may use heat and solvents. The oil oxidizes quickly due to high omega-3 content. Refrigeration essential for food-grade oil.",
    nutritionalProfile: "Exceptional omega-3 content: 53-62% alpha-linolenic acid (ALA). Also contains oleic and linoleic acids. Rich in lignans (antioxidants). Good source of vitamin E.",
    uses: "Nutritional supplement for omega-3s. Added to smoothies and salads (never heated). Industrial oil used in paints, varnishes, and wood finishes. Used in linoleum production.",
    healthBenefits: "Excellent plant source of omega-3 fatty acids. May support heart and brain health. Lignans may have anticancer properties. Supports digestive health.",
    storageShelfLife: "Highly perishable - must be refrigerated. Use within 6-8 weeks of opening. Buy in small quantities. Industrial oil has longer shelf life due to processing.",
    indianNames: {
      Hindi: "Alsi Ka Tel",
      Bengali: "Tishi Tel",
      Gujarati: "Alsi Tel",
      Marathi: "Jawas Tel",
      Tamil: "Ali Virai Ennai",
      Telugu: "Avise Nune"
    },
    specifications: {
      colorRange: "Golden yellow to amber",
      smokePoint: "107°C (225°F) - not for cooking",
      density: "0.925-0.935 g/ml",
      alphaLinolenicAcid: "53-62%",
      iodineValue: "170-204"
    },
    category: "specialty"
  },
  {
    id: "niger-seed-oil",
    name: "Niger Seed Oil",
    botanicalName: "Guizotia abyssinica",
    family: "Asteraceae",
    source: "Niger seeds",
    image: "niger-oil",
    description: "Niger seed oil is extracted from the small black seeds of the niger plant, native to Ethiopia and cultivated in India. It has a pleasant nutty flavor and golden color. Traditionally important in Ethiopian and Indian cuisines.",
    extraction: "Seeds are cleaned and pressed to extract oil. Traditional wooden press (ghani) method produces flavorful oil. Modern expeller and solvent extraction also used. Cold-pressed oil retains nutrients.",
    nutritionalProfile: "High in polyunsaturated fats, especially linoleic acid (75-80%). Good source of vitamin E. Contains oleic acid (5-8%). Low in saturated fats.",
    uses: "Traditional cooking oil in Ethiopia and parts of India. Used in preparation of chutneys and pickles. Seeds used in Indian cooking. Popular bird feed oil in Western countries.",
    healthBenefits: "Rich in essential fatty acids. Good source of antioxidants. May support heart health. Traditional use for skin conditions.",
    storageShelfLife: "Store in cool, dark place. Use within 6-8 months due to high PUFA content. Refrigeration recommended after opening.",
    indianNames: {
      Hindi: "Ramtil Ka Tel",
      Bengali: "Sarguza Tel",
      Kannada: "Uchellu Enne",
      Odia: "Alasi Tela",
      Telugu: "Valiselu Nune"
    },
    specifications: {
      colorRange: "Pale yellow to golden",
      smokePoint: "190°C (374°F)",
      density: "0.924-0.930 g/ml",
      linoleicAcid: "75-80%",
      freefattyAcids: "Max 2% (crude)"
    },
    category: "specialty"
  },
  {
    id: "olive-oil",
    name: "Olive Oil",
    botanicalName: "Olea europaea",
    family: "Oleaceae",
    source: "Olive fruit",
    image: "olive-oil",
    description: "Olive oil is pressed from olives and is central to Mediterranean cuisine. Extra virgin olive oil (EVOO) is cold-pressed without chemicals and has superior flavor. Virgin and refined grades are also available. Known for heart-healthy properties.",
    extraction: "Olives are washed, crushed into paste, and pressed or centrifuged. Extra virgin oil is first cold-press with no chemical treatment. Refined olive oil undergoes processing for neutral flavor.",
    nutritionalProfile: "High in monounsaturated fats (73% oleic acid). Contains polyphenols (powerful antioxidants). Good source of vitamin E and K. Contains squalene and oleocanthal.",
    uses: "Essential in Mediterranean cooking. EVOO best for salads and finishing. Light olive oil suitable for cooking. Used in cosmetics and soap making. Traditional lamp oil.",
    healthBenefits: "Cornerstone of Mediterranean diet. Supports cardiovascular health. Anti-inflammatory properties from oleocanthal. May support brain health. Antioxidant-rich.",
    storageShelfLife: "Store in dark glass away from heat. EVOO best within 18-24 months. Keep away from light which degrades quality. Does not need refrigeration.",
    indianNames: {
      Hindi: "Jaitun Ka Tel",
      Bengali: "Jolpai Tel",
      Gujarati: "Jaitun Tel",
      Tamil: "Olivu Ennai",
      Telugu: "Olive Nune"
    },
    specifications: {
      colorRange: "Green to golden yellow",
      smokePoint: "191°C (375°F) EVOO / 240°C (465°F) refined",
      density: "0.913-0.916 g/ml",
      freefattyAcids: "Max 0.8% (EVOO)",
      oleicAcid: "55-83%"
    },
    category: "premium"
  },
  {
    id: "corn-oil",
    name: "Corn Oil (Maize Oil)",
    botanicalName: "Zea mays",
    family: "Poaceae",
    source: "Corn germ",
    image: "corn-oil",
    description: "Corn oil is extracted from the germ of corn kernels, a byproduct of corn milling. It has a mild flavor and high smoke point. One of the most commonly used vegetable oils in America for frying and baking.",
    extraction: "Corn germ is separated during wet or dry milling. Oil extracted through expeller pressing or solvent extraction. Crude oil is refined, bleached, and deodorized. Cold-pressed varieties available.",
    nutritionalProfile: "High in polyunsaturated fats (59%), primarily linoleic acid. Contains monounsaturated fats (24%). Good source of vitamin E. Rich in phytosterols.",
    uses: "Popular for deep frying and high-heat cooking. Used in baking and salad dressings. Base for margarine production. Used in some industrial applications.",
    healthBenefits: "Plant sterols may help lower cholesterol. Good source of vitamin E. May support heart health when replacing saturated fats.",
    storageShelfLife: "Store in cool, dark place. Shelf life of 1-2 years. Stable for cooking applications. Refrigerate after opening for extended freshness.",
    indianNames: {
      Hindi: "Makka Ka Tel",
      Bengali: "Butta Tel",
      Gujarati: "Makkai Tel",
      Tamil: "Makka Cholam Ennai",
      Telugu: "Mokkajonna Nune"
    },
    specifications: {
      colorRange: "Light yellow to golden",
      smokePoint: "232°C (450°F)",
      density: "0.917-0.925 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      linoleicAcid: "34-62%"
    },
    category: "vegetable"
  },
  {
    id: "rapeseed-oil",
    name: "Rapeseed Oil (Canola Oil)",
    botanicalName: "Brassica napus",
    family: "Brassicaceae",
    source: "Rapeseed",
    image: "rapeseed-oil",
    description: "Rapeseed oil comes from the seeds of the rapeseed plant. Canola is a variety bred to have low erucic acid and glucosinolates. It has a neutral flavor and good fatty acid profile, making it one of the most popular cooking oils worldwide.",
    extraction: "Seeds are cleaned, flaked, and cooked before pressing or solvent extraction. Crude oil undergoes extensive refining. Cold-pressed rapeseed oil retains more flavor and color.",
    nutritionalProfile: "Low in saturated fat (7%). High in monounsaturated fats. Good omega-3 to omega-6 ratio. Contains plant sterols. Good source of vitamin E and K.",
    uses: "Versatile cooking oil for frying, baking, and salads. Used in food manufacturing. Cold-pressed variety for dressings. Major biodiesel feedstock.",
    healthBenefits: "Heart-healthy fatty acid profile. Good omega-3 content for plant oil. May help lower cholesterol. Supports overall cardiovascular health.",
    storageShelfLife: "Store in cool, dark place. Shelf life of 1-2 years. Relatively stable for cooking. Cold-pressed varieties use faster.",
    indianNames: {
      Hindi: "Sarson Ka Tel (related)",
      Bengali: "Sarisha Tel"
    },
    specifications: {
      colorRange: "Light yellow to golden",
      smokePoint: "204°C (400°F) refined",
      density: "0.914-0.920 g/ml",
      freefattyAcids: "Max 0.1% (refined)",
      erucicAcid: "Less than 2% (Canola)"
    },
    category: "vegetable"
  },
  {
    id: "ghee",
    name: "Ghee (Clarified Butter)",
    botanicalName: "From Bos taurus (cattle)",
    family: "Bovidae",
    source: "Milk fat (butter)",
    image: "ghee",
    description: "Ghee is clarified butter with milk solids and water removed through a slow cooking process. It has a rich, nutty flavor and very high smoke point. Central to Indian cuisine and Ayurveda. Desi ghee from indigenous cow breeds is highly prized.",
    extraction: "Butter is slowly simmered until water evaporates and milk solids separate. The clear golden fat is filtered. Traditional bilona method churns curd before making ghee. Quality varies with source and method.",
    nutritionalProfile: "Pure fat - 99.8% fat content. Contains saturated fats (62%), monounsaturated (29%), and polyunsaturated (4%). Contains fat-soluble vitamins A, D, E, K. Contains butyric acid and CLA.",
    uses: "Premium cooking fat in Indian cuisine. Used for tempering (tadka) and sweets. Ritual use in Hindu ceremonies. Ayurvedic medicine applications. Spread and flavor enhancer.",
    healthBenefits: "High smoke point prevents harmful compounds. Butyric acid supports gut health. Contains CLA with potential benefits. Suitable for lactose-intolerant (no milk solids). Ayurvedic medicinal uses.",
    storageShelfLife: "Very stable - doesn't need refrigeration. Shelf life of 6-12 months at room temperature. Can last years if properly made. Store in airtight container.",
    indianNames: {
      Hindi: "Ghee",
      Bengali: "Ghee",
      Gujarati: "Ghee",
      Kannada: "Tuppa",
      Malayalam: "Ney",
      Tamil: "Nei",
      Telugu: "Neyyi"
    },
    specifications: {
      colorRange: "Golden yellow to amber",
      smokePoint: "252°C (485°F)",
      density: "0.93 g/ml at 40°C",
      moisture: "Max 0.3%",
      milkFat: "Min 99.5%"
    },
    category: "animal"
  },
  {
    id: "butter",
    name: "Butter",
    botanicalName: "From Bos taurus (cattle)",
    family: "Bovidae",
    source: "Milk/Cream",
    image: "butter",
    description: "Butter is a dairy product made by churning cream or milk. It contains about 80% fat, with the remainder being water and milk solids. Salted and unsalted varieties available. Quality depends on the source of milk and production method.",
    extraction: "Cream is separated from milk and churned until fat globules aggregate. Water is drained, and butter is worked to achieve desired consistency. Cultured butter is made from fermented cream.",
    nutritionalProfile: "About 80% fat, 16% water, 4% milk solids. High in saturated fat. Contains vitamins A, D, E. Good source of butyric acid. Contains cholesterol.",
    uses: "Cooking and baking staple. Spread for bread and toast. Base for sauces (beurre blanc, hollandaise). Used in pastry making. Flavor enhancer in various cuisines.",
    healthBenefits: "Source of fat-soluble vitamins. Contains butyric acid. CLA content may have benefits. Provides energy. Part of balanced diet in moderation.",
    storageShelfLife: "Refrigerate for 1-3 months. Freeze for longer storage (6-9 months). Salted butter lasts longer. Keep away from strong odors.",
    indianNames: {
      Hindi: "Makhan",
      Bengali: "Makhan",
      Gujarati: "Makhan",
      Tamil: "Vennai",
      Telugu: "Venna"
    },
    specifications: {
      colorRange: "Pale yellow to deep yellow",
      fatContent: "Min 80%",
      moisture: "Max 16%",
      milkSolids: "1-2%",
      saltContent: "0-2% (salted)"
    },
    category: "animal"
  },
  {
    id: "avocado-oil",
    name: "Avocado Oil",
    botanicalName: "Persea americana",
    family: "Lauraceae",
    source: "Avocado fruit pulp",
    image: "avocado-oil",
    description: "Avocado oil is extracted from the pulp of avocados, not the seed. It's one of the few oils derived from fruit flesh. Cold-pressed oil retains nutrients and has a rich, buttery flavor. Refined oil has a neutral taste and very high smoke point.",
    extraction: "Ripe avocados are mashed and the oil separated through centrifugation. Cold-pressed method preserves nutrients and flavor. Refined oil undergoes bleaching and deodorization.",
    nutritionalProfile: "Very high in monounsaturated fats (70% oleic acid). Contains lutein and zeaxanthin. Rich in vitamin E. Contains beta-sitosterol. Low in polyunsaturated fats.",
    uses: "High-heat cooking due to exceptional smoke point. Salad dressings and dips. Skin and hair care products. Carrier oil for aromatherapy. Premium culinary applications.",
    healthBenefits: "Supports heart health. May enhance nutrient absorption. Rich in antioxidants for eye health. Moisturizing for skin. May support joint health.",
    storageShelfLife: "Store in cool, dark place. Shelf life of 8-12 months. Cold-pressed variety best used within 6 months. Does not require refrigeration.",
    indianNames: {
      Hindi: "Avocado Ka Tel",
      Bengali: "Avocado Tel"
    },
    specifications: {
      colorRange: "Green to golden (cold-pressed) / Light yellow (refined)",
      smokePoint: "271°C (520°F) refined",
      density: "0.910-0.920 g/ml",
      oleicAcid: "65-70%",
      freefattyAcids: "Max 0.5% (extra virgin)"
    },
    category: "premium"
  },
  {
    id: "walnut-oil",
    name: "Walnut Oil",
    botanicalName: "Juglans regia",
    family: "Juglandaceae",
    source: "Walnuts",
    image: "walnut-oil",
    description: "Walnut oil is extracted from dried walnuts. It has a delicate, nutty flavor and is prized as a finishing oil. The oil is rich in omega-3 and omega-6 fatty acids. Not suitable for high-heat cooking due to low smoke point.",
    extraction: "Walnuts are cold-pressed to preserve delicate flavors and nutrients. Some refined versions available. Roasted walnut oil has more intense flavor. Cold-pressed oil is the premium variety.",
    nutritionalProfile: "High in polyunsaturated fats including ALA omega-3 (14%). Rich in omega-6 (58%). Contains vitamin E and melatonin. Good source of ellagic acid (antioxidant).",
    uses: "Finishing oil for salads, pasta, and desserts. Used in French cuisine. Baking applications. Not for high-heat cooking. Skin care applications.",
    healthBenefits: "Good plant source of omega-3. Supports heart and brain health. Rich in antioxidants. May help with inflammation. Supports skin health.",
    storageShelfLife: "Highly perishable - refrigerate after opening. Use within 3-6 months. Buy in small quantities. Store in dark bottles.",
    indianNames: {
      Hindi: "Akhrot Ka Tel",
      Bengali: "Akhrot Tel"
    },
    specifications: {
      colorRange: "Light yellow to golden",
      smokePoint: "160°C (320°F)",
      density: "0.921-0.927 g/ml",
      alphaLinolenicAcid: "12-14%",
      linoleicAcid: "56-60%"
    },
    category: "premium"
  },
  {
    id: "almond-oil",
    name: "Almond Oil",
    botanicalName: "Prunus dulcis",
    family: "Rosaceae",
    source: "Sweet almonds",
    image: "almond-oil",
    description: "Sweet almond oil is extracted from edible almonds. It has a mild, slightly sweet, nutty flavor. Widely used in both culinary and cosmetic applications. Bitter almond oil (from different variety) is toxic and used only in processing.",
    extraction: "Almonds are cold-pressed to extract oil. Refined versions available for cooking. Cosmetic-grade oil may undergo additional processing. Quality varies significantly by source.",
    nutritionalProfile: "High in monounsaturated fats (66% oleic acid). Contains vitamin E (26mg/100g). Good source of omega-6. Contains squalene and phytosterols.",
    uses: "Culinary finishing oil. Widely used in cosmetics and skincare. Traditional massage oil. Used in marzipan and confectionery. Hair care applications.",
    healthBenefits: "Excellent for skin moisturizing. Rich in vitamin E antioxidants. Supports heart health. May help with skin conditions. Traditional use in Ayurveda.",
    storageShelfLife: "Store in cool, dark place. Culinary oil lasts 6-12 months. Cosmetic-grade may have preservatives. Refrigerate after opening.",
    indianNames: {
      Hindi: "Badam Ka Tel",
      Bengali: "Badam Tel",
      Gujarati: "Badam Tel",
      Tamil: "Badam Ennai",
      Telugu: "Badam Nune"
    },
    specifications: {
      colorRange: "Pale yellow to golden",
      smokePoint: "216°C (420°F)",
      density: "0.910-0.915 g/ml",
      oleicAcid: "62-86%",
      freefattyAcids: "Max 1.5%"
    },
    category: "premium"
  }
];

// Get all unique categories
export const oilCategories = [...new Set(edibleOilsData.map(o => o.category))];

// Get oil by ID
export const getOilById = (id) => edibleOilsData.find(o => o.id === id);

// Get oils by category  
export const getOilsByCategory = (category) => edibleOilsData.filter(o => o.category === category);

// Category labels
export const oilCategoryLabels = {
  vegetable: "Vegetable Oils",
  tropical: "Tropical Oils",
  premium: "Premium Oils",
  specialty: "Specialty Oils",
  industrial: "Industrial Oils",
  animal: "Animal Fats"
};
